export class BillingBase {
    id:string;
    country: string;
    region: string;
    city: string;
    address: string;
    phoneNumber: string;
    email: string;
    postalCode:string;
}

export class InvoiceDataCompany extends BillingBase{
    companyName: string;
    administratorName: string;
    cui: string;
    platitorTVA: boolean;
    bankName: string;
    ibanAccountNumber:string
    registrationNumber:string;

    static from(data):InvoiceDataCompany{
        return {
            id: data.id,
            country: data.country,
            region: data.region,
            city: data.city,
            address: data.address,
            phoneNumber: data.phoneNumber,
            email: data.email,
            postalCode: data.postalCode,
            companyName: data.companyName,
            administratorName: data.administratorName,
            cui: data.cui,
            platitorTVA: data.platitorTVA,
            bankName: data.bankName,
            ibanAccountNumber: data.ibanAccountNumber,
            registrationNumber: data.registrationNumber
        }
    }
}

export class InvoiceDataPerson extends BillingBase{
    fullName: string;
    cnp: string;
    ci: string;

    static from(data):InvoiceDataPerson{
        return {
            id: data.id,
            country: data.country,
            region: data.region,
            city: data.city,
            address: data.address,
            phoneNumber: data.phoneNumber,
            email: data.email,
            postalCode: data.postalCode,
            fullName: data.fullName,
            cnp: data.cnp,
            ci: data.ci
        }
    }
}

export class Judet{
    cod: string;
    judet: string;
    resedinta: string;
    suprafata: string;
    populatie: number;
}

export const LISTA_JUDETE: Judet[] = [
    {cod:"B", judet:"București", resedinta: "București", suprafata:"228" , populatie: 1716961},
    {cod:"AB", judet:"Alba", resedinta: "Alba Iulia", suprafata:"6242" , populatie: 325941},
    {cod:"AR", judet:"Arad", resedinta: "Arad", suprafata:"7754" , populatie: 410143},
    {cod:"AG", judet:"Arges", resedinta: "Pitești", suprafata:"6826" , populatie: 569932},
    {cod:"BC", judet:"Bacău", resedinta: "Bacău", suprafata:"6621" , populatie: 601387},
    {cod:"BH", judet:"Bihor", resedinta: "Oradea", suprafata:"7544" , populatie: 551297},
    {cod:"BN", judet:"Bistrița-Năsăud", resedinta: "Bistrița", suprafata:"5355" , populatie: 295988},
    {cod:"BT", judet:"Botoșani", resedinta: "Botoșani", suprafata:"4986" , populatie: 392821},
    {cod:"BV", judet:"Brașov", resedinta: "Brașov", suprafata:"5363" , populatie: 546615},
    {cod:"BR", judet:"Brăila", resedinta: "Brăila", suprafata:"4766" , populatie: 281452},
    {cod:"BZ", judet:"Buzău", resedinta: "Buzău", suprafata:"6103" , populatie: 404979},
    {cod:"CS", judet:"Caraș-Severin", resedinta: "Reșița", suprafata:"8520" , populatie: 246588},
    {cod:"CL", judet:"Călărași", resedinta: "Călărasi", suprafata:"5088" , populatie: 283458},
    {cod:"CJ", judet:"Cluj", resedinta: "Cluj-Napoca", suprafata:"6674" , populatie: 679141},
    {cod:"CT", judet:"Constanța", resedinta: "Constanța", suprafata:"7071" , populatie: 655997},
    {cod:"CV", judet:"Covasna", resedinta: "Sfântu Gheorghe", suprafata:"3710" , populatie: 200042},
    {cod:"DB", judet:"Dâmbovița", resedinta: "Târgoviște", suprafata:"4054" , populatie: 479404},
    {cod:"DJ", judet:"Dolj", resedinta: "Craiova", suprafata:"7414" , populatie: 599442},
    {cod:"GL", judet:"Galați", resedinta: "Galați", suprafata:"4466" , populatie: 496892},
    {cod:"GR", judet:"Giurgiu", resedinta: "Giurgiu", suprafata:"3526" , populatie: 262066},
    {cod:"GJ", judet:"Gorj", resedinta: "Târgu Jiu", suprafata:"5602" , populatie: 314685},
    {cod:"HR", judet:"Harghita", resedinta: "Miercurea-Ciuc", suprafata:"6639" , populatie: 291950},
    {cod:"HD", judet:"Hunedoara", resedinta: "Deva", suprafata:"7063" , populatie: 361657},
    {cod:"IL", judet:"Ialomița", resedinta: "Slobozia", suprafata:"4453" , populatie: 250816},
    {cod:"IS", judet:"Iași", resedinta: "Iași", suprafata:"5476" , populatie: 760774},
    {cod:"IF", judet:"Ilfov", resedinta: "București", suprafata:"1593" , populatie: 542704},
    {cod:"MM", judet:"Maramureș", resedinta: "Baia Mare", suprafata:"6304" , populatie: 452475},
    {cod:"MH", judet:"Mehedinți", resedinta: "Drobeta-Turnu Severin", suprafata:"4933" , populatie: 234339},
    {cod:"MS", judet:"Mureș", resedinta: "Târgu Mureș", suprafata:"6714" , populatie: 518193},
    {cod:"NT", judet:"Neamț", resedinta: "Piatra Neamț", suprafata:"5896" , populatie: 454203},
    {cod:"OT", judet:"Olt", resedinta: "Slatina", suprafata:"5498" , populatie: 383280},
    {cod:"PH", judet:"Prahova", resedinta: "Ploiești", suprafata:"4716" , populatie: 695119},
    {cod:"SM", judet:"Satu Mare", resedinta: "Satu Mare", suprafata:"4418" , populatie: 330668},
    {cod:"SJ", judet:"Sălaj", resedinta: "Zalău", suprafata:"3864" , populatie: 212224},
    {cod:"SB", judet:"Sibiu", resedinta: "Sibiu", suprafata:"5432" , populatie: 388326},
    {cod:"SV", judet:"Suceava", resedinta: "Suceava", suprafata:"8553" , populatie: 642551},
    {cod:"TR", judet:"Teleorman", resedinta: "Alexandria", suprafata:"5790" , populatie: 323544},
    {cod:"TM", judet:"Timiș", resedinta: "Timișoara", suprafata:"8697" , populatie: 650533},
    {cod:"TL", judet:"Tulcea", resedinta: "Tulcea", suprafata:"8499" , populatie: 193355},
    {cod:"VL", judet:"Vâlcea", resedinta: "Râmnicu Vâlcea", suprafata:"5765" , populatie: 374700},
    {cod:"VS", judet:"Vaslui", resedinta: "Vaslui", suprafata:"5318" , populatie: 341861},
    {cod:"VN", judet:"Vrancea", resedinta: "Focșani", suprafata:"4857" , populatie: 335312},
    {cod:"VN", judet:"Vrancea", resedinta: "Focșani", suprafata:"4857" , populatie: 335312},
]

